import { GameVars } from "../../GameVars";
import { DailyRewardState } from "./DailyRewardState";

export class DailyRewardMessage extends Phaser.Group {

    private getLabel: Phaser.Sprite;
    private yourLabel: Phaser.Sprite;
    private dailyLabel: Phaser.Sprite;
    private rewardLabel: Phaser.Sprite;

    constructor(game: Phaser.Game) {

        super(game, null, "daily-reward-message", false);

        this.x = 390;
        this.y = 400;

        this.scale.y = GameVars.scaleY;

        var labelScale = 1.65;

        this.getLabel = this.create(0, 0, "texture_atlas_6", "message_01_get");
        this.getLabel.anchor.setTo(.5);
        this.getLabel.scale.setTo(labelScale);
        this.getLabel.visible = false;

        this.yourLabel = this.create(-68, 78, "texture_atlas_6", "message_02_your");
        this.yourLabel.anchor.setTo(.5);
        this.yourLabel.scale.setTo(labelScale);
        this.yourLabel.visible = false;

        this.dailyLabel = this.create(60, 72, "texture_atlas_6", "message_03_daily");
        this.dailyLabel.anchor.setTo(.5);
        this.dailyLabel.scale.setTo(labelScale);
        this.dailyLabel.visible = false;

        this.rewardLabel = this.create(0, 142, "texture_atlas_6", "message_04_reward");
        this.rewardLabel.anchor.setTo(.5);
        this.rewardLabel.scale.setTo(labelScale);
        this.rewardLabel.visible = false;
    }

    public appear(): void {

        this.getLabel.visible = true;

        this.game.add.tween(this.getLabel.scale)
            .to({ x: 1, y: 1 }, 300, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {

                this.yourLabel.visible = true;

                this.game.add.tween(this.yourLabel.scale)
                    .to({ x: 1, y: 1 }, 300, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function (): void {

                        this.dailyLabel.visible = true;

                        this.game.add.tween(this.dailyLabel.scale)
                            .to({ x: 1, y: 1 }, 300, Phaser.Easing.Cubic.Out, true)
                            .onComplete.add(function (): void {

                                this.rewardLabel.visible = true;
                                this.game.add.tween(this.rewardLabel.scale)
                                    .to({ x: 1, y: 1 }, 300, Phaser.Easing.Cubic.Out, true)
                                    .onComplete.add(function () {
                                        this.disappear();
                                    }, this);
                            }, this);

                    }, this);
            }, this);
    }

    private disappear(): void {

        this.game.add.tween(this)
            .to({ alpha: 0 }, 500, Phaser.Easing.Cubic.Out, true, 1800)
            .onComplete.add(function (): void {

                DailyRewardState.currentInstance.showBall();

                this.destroy();
            }, this);
    }
}
